import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/services/query-keys';
import { tradesService } from '@/services/trades/trades-service';

/**
 * Check if a given date is a public holiday.
 * Only fetches when date is provided and enabled is true.
 */
export const useCheckHoliday = (date: string | undefined, enabled = true) => {
  return useQuery({
    queryKey: queryKeys.trades.holidayCheck(date ?? ''),
    queryFn: () => tradesService.checkHoliday(date!),
    enabled: !!date && enabled,
    staleTime: 30 * 60 * 1000, // 30 minutes
  });
};
